import Vue from 'vue';
import Vuex from 'vuex';
import types from './modules/typeList';
import user from './modules/user';
import system from './modules/system';
import region from './modules/region';
Vue.use(Vuex);

// 新建并暴露store
export default new Vuex.Store({
    modules: {
        types,
        user,
        system,
        region,
    },
});
